















import Vue from 'vue';
import Component from 'vue-class-component';
import router from '@/router';
import { ObjectFactory } from '../config/objectFactory';
import { MedTransGoConstants } from '../util/constants';
import DataTable from '../components/DataTable.vue';
import { CommonUtils } from '../util/commonUtils';
import { ApiRequest, QueryRecordsRequest } from '../types/request';
import { DateUtils } from '../util/dateUtils';
import { MathUtils } from '../util/mathUtils';
import { Invoice, Payout } from '../types/entity';
import ViewRequestDetailModal from './modal/ViewRequestDetailModal.vue';
import { Condition } from '../types/queryRequest';


// tslint:disable-next-line: no-var-requires
const PayoutsTable = require('../datatable/PayoutsTable.json');
@Component({
    watch: {
        $route(to, from) {
            const request = this as Payouts;
            request.getPayoutList();
        },
    },
    methods: {
        goBack() {
            router.push({ name: MedTransGoConstants.VIEW_REQUESTS_PANEL_NAME });
        },
    },
    components: {
        DataTable,
        ViewRequestDetailModal,
    },
})
export default class Payouts extends Vue {
    private payoutsDataSource = PayoutsTable;
    private show = true;

    public mounted() {
        if (this.$store.state.isChildInterpreter) {
            this.show = false;
        }
        this.getPayoutList('', 0);
    }

     private showViewRequestModal(serviceRequest: any) {
        this.$router.push({ path: `/payouts/${serviceRequest.requestId}` });
    }

    private async getPayoutList(searchString?: string, start?: number, conditions?: Condition[]) {
        const response = await ObjectFactory.getRequestService().getPayouts({
                   conditions: this.getFilterConditions(),
                   start,
                    limit: MedTransGoConstants.PAGINATION_LIMIT,
                }, this.$store.state.serverUrl);
        this.payoutsDataSource.data = response.data;
        if (response.totalCount) {
            this.payoutsDataSource.totalCount = response.totalCount;
        }
    }
    private getFilterConditions(): Condition[] {
        const filterConditions: Condition[] = [];
        let datasource;
        datasource = this.payoutsDataSource;
        datasource.filters.forEach((filter: any) => {
            if (filter.name === 'StatusFilter') {
                const selectedStatus: string[] = [];
                filter.values.forEach((filterValue: any) => {
                    if (filterValue.value) {
                        selectedStatus.push(filterValue.dbValue);
                    }
                });
                if (selectedStatus.length > 0) {
                    filterConditions.push({
                        fieldName: 'status',
                        op: 'in',
                        value: selectedStatus,
                    });
                }
            }
        });
        return filterConditions;
    }

    private async filterRequests(filter: any) {
        this.getPayoutList('', 0);
    }
}
